// Helpers used across the app
export const BLUE = "#2563eb";
export const BLUE_DARK = "#1d4ed8";
export const HEADER_BG = "#1e3a8a";
export const GRID_BORDER = "#e2e8f0";

export const STATUS_CONFIG = {
  received: { label: "Recebido", bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200" },
  ready: { label: "Pronto", bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200" },
  delivered: { label: "Entregue", bg: "bg-slate-100", text: "text-slate-700", border: "border-slate-300" },
};

export const PAY_LABELS = {
  pix_loja: "Pix Loja",
  pix_kevin: "Pix Kevin",
  dinheiro: "Dinheiro",
  cartao: "Cartão",
  anotar: "Anotar",
  devolvido: "Devolvido",
};

export const PAY_COLORS = {
  pix_loja: { bg: "#dcfce7", color: "#166534", border: "#86efac" },
  pix_kevin: { bg: "#d1fae5", color: "#065f46", border: "#6ee7b7" },
  dinheiro: { bg: "#fef9c3", color: "#854d0e", border: "#fde047" },
  cartao: { bg: "#e0e7ff", color: "#3730a3", border: "#a5b4fc" },
  anotar: { bg: "#fee2e2", color: "#991b1b", border: "#fca5a5" },
  devolvido: { bg: "#f3e8ff", color: "#6b21a8", border: "#d8b4fe" },
};

export const COLOR_MAP = {
  Preto: "#1c1c1e",
  Branco: "#f8fafc",
  Vermelho: "#dc2626",
  Laranja: "#ea580c",
  Dourado: "#c9a84c",
  Azul: "#4a7fb5",
  Rosa: "#e8a0b4",
  Roxo: "#7e5a9b",
  Lilás: "#c5a8d4",
  Amarelo: "#f5d76e",
  Verde: "#5a9e6f",
  Deserto: "#c4a882",
  Natural: "#e8dcc8",
};

export function fmtBRL(val) {
  const n = Number(val) || 0;
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function monthLabel(key) {
  const [m, y] = key.split("/");
  const names = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
  return `${names[parseInt(m) - 1]}/${y}`;
}

export function digits(str) {
  return String(str || "").replace(/\D/g, "");
}

export function waLink(phone, message) {
  const d = digits(phone);
  const number = d.startsWith("55") ? d : `55${d}`;
  return `https://wa.me/${number}?text=${encodeURIComponent(message || "")}`;
}
